import * as v from 'valibot'

export enum CookieCategory {
  Essential = 'essential',
  Analytics = 'analytics',
  Marketing = 'marketing',
}

const cookieConsentPermissionsSchema = v.object({
  category: v.enum(CookieCategory),
  excluded: v.optional(v.array(v.string())),
})

export type CookieConsentPermissions = v.InferOutput<
  typeof cookieConsentPermissionsSchema
>

export const cookieConsentSchema = v.object({
  prompted: v.boolean(),
  datestamp: v.string(),
  permissions: v.array(cookieConsentPermissionsSchema),
  version: v.optional(v.string()),
})

export type CookieConsent = v.InferOutput<typeof cookieConsentSchema>
